export default __webpack_public_path__ + "static/media/comercio_10.c911c238.png";